var map = {
	"./act": 1488,
	"./act.ts": 1488,
	"./gmat": 1489,
	"./gmat.ts": 1489,
	"./gre": 1490,
	"./gre.ts": 1490,
	"./ielts": 1491,
	"./ielts.ts": 1491,
	"./ielts_general_training": 1492,
	"./ielts_general_training.ts": 1492,
	"./lsat": 1493,
	"./lsat.ts": 1493,
	"./mcat": 1494,
	"./mcat.ts": 1494,
	"./sat": 1495,
	"./sat.ts": 1495,
	"./toefl": 1496,
	"./toefl.ts": 1496
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2502;
module.exports = webpackAsyncContext;